require('../jhire/modules/jv.webpack.js');   
require('../../lib/js/angularmodule/JV.Core.Directives');
require('../common/directives/jv.AjaxSelect.js');
require('../common/jv.Jobvite.Urls');
require('../common/jv.i18n');
require('./jv.Candidates.LinkedIn.Controller');
require('./jv.candidates.service');
require('../../stylekit/js/jv.SortList.js');
require('../common/jv.log4javascript.webpack.js');
var app = angular.module('jv.Candidates.LinkedIn.app', [
    'ngRoute',
    'jv',
    'JV.Core.Directives',
    'jv.services',
    'ngSanitize',
    'jv.candidates.service',
    'jv.Common.Jobvite.Urls',
    'jv.Common.i18n',
    'jv.candidates.LinkedIn.controller',
    'jv.Common.Directives.SortList',
    'jv.log4javascript'
]);

app.value('modalTemplateUrl', '../../htm/common/modal.html');
app.value('messageBarTemplateUrl', '../../htm/common/messageBar.html');